import
  React
from 'react';

import {
  ContactUs
} from 'src/Common/constants';

import {
  AuthInfoClockIcon,
  AuthInfoStatus,
  AuthInfoUploadIcon,
  DigiCertLogo,
  QuestionMarkIcon,
  SymantecLogo,
} from 'src/Components/Common';

import './AuthInfo.css';

const items = [
  <p key={1}>
    We'll ask you for your <strong>personal info</strong> to authenticate this
    application.
  </p>,
  <p key={2}>
    You'll select where you'd like to take <strong>delivery</strong> of your
    order.
  </p>,
  <p key={3}>
    Lastly, you'll be able to double-check your order and
    <strong> submit your application.</strong>
  </p>,
];

const questions = [
  {
    image: <AuthInfoClockIcon />,
    que: <p className="auth-info-question">How long will it take?</p>,
    ans: (
      <React.Fragment>
        <p className="auth-info-text">
          The online application process can take between 8 - 15
          minutes, depending on your connectivity and the speed of your fingers.
        </p>
      </React.Fragment>
    ),
    divider: <hr className="auth-info-divider" />,
  },
  {
    image: <AuthInfoUploadIcon />,
    que: <p className="auth-info-question">Will I need to upload documents?</p>,
    ans: (
      <React.Fragment>
        <p className="auth-info-text">
          Current Vodacom customers are not required to submit any documents
          during the online application process, while new Vodacom customers
          will need to provide documentation.
        </p>
      </React.Fragment>
    ),
    divider: <hr className="auth-info-divider" />,
  },
  {
    image: <AuthInfoStatus />,
    que: <p className="auth-info-question">What will I need to do?</p>,
  },
];

const logos = [
  {
    firstLogo: <SymantecLogo />,
    SecondLogo: <DigiCertLogo />,
    thirdLogo: <QuestionMarkIcon />,
    text: 'Need Help?',
    contact: 'Email us',
  },
];

function AuthInfo() {
  const emailUs = (e) => {
    e.preventDefault();
    window.open(`mailto: ${ContactUs.Email}`, '_blank');

  };

  return (
    <>
      <div className="auth-info-wrapper">
        <div className="auth-info-heading">Curious about what to expect?</div>
        <p className="auth-info-sub-text">
          Here are some frequently asked questions about our online application
          process
        </p>

        { questions.map((question, index) => (
          <React.Fragment key={index}>

            <div className="auth-info-sub-heading" >
              <span>{question.image}</span>
              {question.que}
            </div>

            <div className="auth-info-answer">
              {question.ans}
              {question.divider}
            </div>
          </React.Fragment>
        ))}

        <p className="auth-info-sub-sub-heading">
          You can expect the following:
        </p>
        <ul className="auth-info-list">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      { logos.map((logo, index) => (
        <footer className="auth-info-footer" key={index}>
          <div className="auth-info-logo">
            <span className="auth-info-footer-text"> Secured by: </span>
            <span className="auth-info-symentics-logo">{logo.firstLogo}</span>
            <span className="auth-info-digicerti-logo">{logo.SecondLogo}</span>
          </div>
          <div className="auth-info-help">
            <span className="auth-info-questionmark-icon">
              {logo.thirdLogo}
            </span>
            <span className="auth-info-help-text">{logo.text}</span>
            <span className="auth-info-contact-us">
              <a className='auth-info-email-link' href="url" onClick={emailUs}>
              {logo.contact}
              </a>
              <span className='auth-info-email-link-text' >{' '}or call us{' '}</span>
               {ContactUs.Phone}
            </span>
          </div>
        </footer>
      ))}
    </>
  );
}

export default AuthInfo;
